// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"98f54135","378":"a5c1e935","453":"1b7d953a","543":"ccc2dbca","714":"4b87e1db"}[chunkId] + ".chunk.js";
};